const sections = document.querySelectorAll('section.trainer');

if (sections.length > 0) {
    const handleButtonVisibility = (bio, buttonWrapper, button) => {
        if (window.innerWidth > 991.98) {
            if (bio.offsetHeight > 423) {
                buttonWrapper.classList.remove('d-none');
            } else {
                buttonWrapper.classList.add('d-none');
            }
        } else {
            if (bio.offsetHeight > 87) {
                buttonWrapper.classList.remove('d-none');
            } else {
                buttonWrapper.classList.add('d-none');
            }
        }
    };

    const handleButtonEvent = (bio, buttonWrapper, button) => {
        const hideText = button.getAttribute('data-hide-text');
        const moreText = button.getAttribute('data-more-text');
        button.addEventListener('click', () => {
            const bioParent = bio.parentElement;

            if (bioParent.classList.contains('-show')) {
                window.scrollTo({
                    top: bio.getBoundingClientRect().top + window.scrollY - 250,
                });
                setTimeout(() => {
                    bioParent.classList.remove('-show');
                    buttonWrapper.classList.remove('-active');
                    button.textContent = moreText;
                }, 300);
            } else {
                bioParent.classList.add('-show');
                buttonWrapper.classList.add('-active');
                button.textContent = hideText;
            }
        });
    };

    const handleSection = section => {
        const bio = section.querySelector('.trainer__bio');
        const buttonWrapper = section.querySelector('.trainer__button-wrapper');
        const button = buttonWrapper.querySelector('.trainer__button');
        handleButtonVisibility(bio, buttonWrapper, button);
        handleButtonEvent(bio, buttonWrapper, button);
        window.addEventListener('resize', () => {
            handleButtonVisibility(bio, buttonWrapper, button);
        });
    };

    sections.forEach(section => {
        handleSection(section);
    });
}
